import { IreservationStep1, IreservationStep2, IreservationStep3 } from "./interfaces";

const fetchLocalStorageData = (key: string) => {
  let result = localStorage.getItem(key);
  if (!result) return null;
  return JSON.parse(result);
};


// createReservation
export const getReservation = () => {
  let reservation = fetchLocalStorageData("miramontilaltro_reservation");

  if (!reservation) reservation = {
    people: '',
    service: '',
    date: undefined,
    slot: '',
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    emailCheck: '',
    note: '',
    gdpr: false,
    mailingList: false,
    status: 'pending',
    allergies: [],
  }
  return reservation;
}

export const updateReservationStep1 = (data: IreservationStep1) => {

  const newData: IreservationStep1 = {
    people: data.people,
    service: data.service,
    date: data.date,
    slot: data.slot,
    status: data.status,
  };

  let reservation = getReservation();
  return localStorage.setItem(
    "miramontilaltro_reservation",
    JSON.stringify({ ...reservation, ...newData })
  );
}

export const updateReservationStep2 = (data: IreservationStep2) => {

  const newData : IreservationStep2 = {
    firstName: data.firstName,
    lastName: data.lastName,
    phone: data.phone,
    email: data.email,
    emailCheck: data.emailCheck
  };

  let reservation = getReservation();
  return localStorage.setItem(
    "miramontilaltro_reservation",
    JSON.stringify({ ...reservation, ...newData })
  );
}

export const updateReservationStep3 = (data: IreservationStep3) => {

  const newData : IreservationStep3 = {
    allergies: data.allergies,
    gdpr: data.gdpr,
    mailingList: data.mailingList,
    note: data.note,
    menu: data.menu,
  };

  let reservation = getReservation();
  return localStorage.setItem(
    "miramontilaltro_reservation",
    JSON.stringify({ ...reservation, ...newData })
  );
}

export const deleteReservation = () => {
  return localStorage.removeItem("miramontilaltro_reservation");
}
